export default "__VITE_ASSET__DjAHShv1__"